import {Switch} from 'antd';
import React from 'react';

interface ToggleProps {
  checked?: boolean;
  onChange?: (checked: boolean) => void;
}

const Toggle: React.FC<ToggleProps> = ({checked = false, onChange}) => {
  return (
    <Switch className="pcf-toggle" checked={checked} onChange={onChange} />
  );
};

export default Toggle;
